import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import UserManualNew from './user_manual_new';

const style = {
  position: 'absolute',
  top: '7%',
  left: '5%',
  height: '86%',
  width: '90%',
  bgcolor: '#0d2147',
  boxShadow: 24,
  borderRadius: 2,
  overflow: 'auto',
};

export default function UserManualNewPopup({ open, onClose }) {
  const isBigScreen = useMediaQuery('(min-width:1024px)');

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="user-manual-new" aria-describedby="user-manual-new-desc">
      <Box sx={style}>
        <CancelOutlinedIcon
          onClick={onClose}
          sx={{
            color: '#fff',
            backgroundColor: '#3F69F8',
            borderRadius: '50%',
            p: 0.5,
            top: 'calc(7% - 12px)',
            left: 'calc(95% - 13px)',
            height: 24,
            width: 24,
            cursor: 'pointer',
            position: 'fixed',
            zIndex: 1300,
            '&:hover': { backgroundColor: '#3357d6' },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            mt: 0,
            pt: 0,
            background: '#132d5a',
            width: '100%',
            height: '100%',
            overflow: 'auto',
            scrollBehavior: 'smooth',
            '&::-webkit-scrollbar': { width: 6, height: 6 },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#3F69F8', borderRadius: 3 },
            flexDirection: isBigScreen ? 'row' : 'column',
            overflow: 'auto',
            scrollBehavior: 'smooth',
            '&::-webkit-scrollbar': { width: 6, height: 6 },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#3F69F8', borderRadius: 3 },
          }}
        >
          <UserManualNew />
        </Box>
      </Box>
    </Modal>
  );
}
